import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {AutenticacaoService} from 'app/shared/clients/user-client';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    /**
     * @param {Router} _router
     * @param {AutenticacaoService} _authenticationService
     */
    constructor(private _router: Router, private _authenticationService: AutenticacaoService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {
                if ([401, 403].indexOf(err.status) !== -1) {
                    // Não fazer logout em rotas públicas
                    const isPublicRoute = this._router.url.startsWith('/campanha/');
                    
                    if (!isPublicRoute) {
                        // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                        this._authenticationService.sair();
                    }
                }
                return throwError(err.error);
            })
        );
    }
}
